/**
 * Formatting helpers for invoices coming from the external Claro payment panel
 * (the 402 payment-required body and /subscription/panel-invoices). The panel
 * sends display-ready strings: dates as yyyy-MM-dd, amounts as "861,00 PLN".
 * Shared by PaymentRequiredModal and MySubscriptionPage so the panel's wire
 * conventions are decoded in one place.
 */

/** yyyy-MM-dd → dd/MM/yyyy; anything else is passed through untouched. */
export function formatPanelDate(dateStr: string): string {
  if (!dateStr) return ''
  const parts = dateStr.split('-')
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`
  return dateStr
}

/** Split "861,00 PLN" into amount and currency for separate styling. */
export function splitAmount(value: string): {
  amount: string
  currency: string
} {
  if (!value) return { amount: '', currency: '' }
  const match = value.match(/^(.+?)\s*(PLN|EUR|USD|GBP|CZK)$/i)
  if (match) return { amount: match[1].trim(), currency: match[2] }
  return { amount: value, currency: '' }
}
